import { defineComponent as _defineComponent } from 'vue'
import { isExternal } from '@/utils/validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItemLink',
  props: {
    to: null
  },
  setup(__props: any) {

const props = __props as {
  to: string
}


const checkIsExternal = isExternal

return { __sfc: true,props, checkIsExternal }
}

})